import { Card, CardContent, Typography, Box } from '@mui/material';
import { ReactNode } from 'react';

interface StatsCardProps {
  title: string;
  value: string | number;
  icon: ReactNode;
  color?: string;
  subtitle?: string;
}

export function StatsCard({ title, value, icon, color = 'primary.main', subtitle }: StatsCardProps) {
  return (
    <Card
      sx={{
        height: '100%',
        minHeight: 150,
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        borderLeft: '4px solid',
        borderLeftColor: color,
        boxShadow: '0 2px 10px rgba(15, 23, 42, 0.04)',
        position: 'relative',
        backgroundColor: 'background.paper',
        transition: 'box-shadow 0.2s ease, border-color 0.2s ease',
        '&:hover': {
          boxShadow: '0 6px 18px rgba(15, 23, 42, 0.08)',
          borderColor: `${color}55`,
        },
      }}
    >
      <CardContent sx={{ p: 2.5, '&:last-child': { pb: 2.5 } }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1.5 }}>
          <Typography
            variant="overline"
            color="text.secondary"
            sx={{ letterSpacing: 0.6, fontWeight: 700, lineHeight: 1.2 }}
          >
            {title}
          </Typography>
          <Box
            sx={{
              color: color,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 32,
              height: 32,
              borderRadius: 1.5,
              backgroundColor: `${color}14`,
            }}
          >
            {icon}
          </Box>
        </Box>
        <Typography variant="h4" component="div" sx={{ mb: 0.75, fontWeight: 700, lineHeight: 1 }}>
          {value}
        </Typography>
        {subtitle ? <Typography variant="body2" color="text.secondary">{subtitle}</Typography> : null}
      </CardContent>
    </Card>
  );
}
